import ko from 'knockout';
import _ from 'underscore';
import URI from 'urijs';
import config from '@bingads-webui-component-legacy/config/index';
import { DynamicSearchAd, DisclaimerAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';
import dynamicTextExtension from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/dynamicTextExtension';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import getDomain from '@bingads-webui-campaign-legacy/crud-ad/service/getDomain';
import maxLengthExtension from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/maxLengthExtension';
import parsedTextMaxLengthExtension from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/parsedTextMaxLengthExtension';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import pageContext from '@bingads-webui-static-legacy/page-context';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const permissions = config.get('Permissions') || {};

export default class ViewModel {
  constructor({
    model = null,
    useUpgradedUrl = false,
    isTraditionalChinese = false,
    scope = null,
    activityLogger,
  } = {}) {
    this.upgradedUrlFields = _.compact(['TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix']);
    this.activityLogger = activityLogger;
    this.fields = [
      'Text',
      'TextPart2',
      'Path1',
      'Path2',
      ...useUpgradedUrl ? this.upgradedUrlFields : [],
    ];
    this.scope = scope;

    const customValidation = {
      Path2: {
        isValid: (value) => {
          return _.isEmpty(value) || !_.isEmpty(_.result(this, 'Path1'));
        },
        message: i18n.get('ExpandedTextAd_Path1RequiredWhenUsingPath2'),
      },
    };

    koSchema.properties(this, DynamicSearchAd, this.fields, model, customValidation);

    this.domain = ko.computed(() => {
      let domain = _.result(model, 'DisplayUrl') || scope().campaignDomain;

      return getDomain(domain || '');
    });

    this.protocol = ko.computed(() => {
      const uri = new URI(_.result(model, 'DisplayUrl') || '');

      return uri.protocol() || 'https';
    });

    this.isDynamicDescriptionEnabled = ko.computed(() => {
      return _.result(permissions.dynamic, 'DSADynamicDescriptionPhase1', false) && scope().isDynamicDescriptionEnabled;
    });

    this.isAllowDisclaimer = ko.computed(() => {
      return scope().isDynamicDescriptionEnabled;
    });
    this.disclaimerInfo = ko.observable({});
    this.scope.subscribe((data) => {
      if (data.campaignId ) {
        this.computeDisclaimerAsync(data.campaignId);
      }
    });

    this.extensionsSharedRepos = new SharedRepository({
      schema: DisclaimerAdExtension,
      afterChangeComitted: _.noop,
    });

    let disclaimerCampaignId = 0;

    if (Number(scope().campaignId) > 0) {
      disclaimerCampaignId = Number(scope().campaignId);
    } else if (pageContext.CurrentCampaign && Number(pageContext.CurrentCampaign.Id) > 0) {
      disclaimerCampaignId = Number(pageContext.CurrentCampaign.Id);
    }

    if (disclaimerCampaignId  > 0 ) {
      this.computeDisclaimerAsync(disclaimerCampaignId);
    }

    this.showDisclaimer =  ko.computed(() => {
      if (this.disclaimerInfo().Id) {
        return true;
      }

      return false;
    });

    this.adDisclaimerHint = ko.computed(() => {
      if (this.disclaimerInfo().Id ) {
        if (this.disclaimerInfo().DisclaimerLayout === 'AdditionalLine') {
          return i18n.getString('Disclaimer_Ad_AdditionalLine_Hint');
        } else if (this.disclaimerInfo().DisclaimerLayout === 'Popup') {
          return i18n.getString('Disclaimer_Ad_Popup_Hint');
        }
      }

      return '';
    });

    this.Path1.subscribe(() => {
      this.Path2.validate();
    });

    const lengthExtensionProperties = ['Text', 'TextPart2'];

    dynamicTextExtension.extend(this, lengthExtensionProperties);

    maxLengthExtension(DynamicSearchAd, this, isTraditionalChinese, lengthExtensionProperties);

    if (permissions.IsIffCountdownForDSAEnabled) {
      const fieldsThatUseAdCustomizers = [
        'Text',
        'TextPart2',
        'Path1',
        'Path2',
      ];

      parsedTextMaxLengthExtension.extend(this, fieldsThatUseAdCustomizers, 'DynamicSearchAd');
    }

    _.each(this.fields, (field) => {
      // log once per field.
      const logChange = _.once(() => {
        if (this.activityLogger) {
          this.activityLogger.signal(`ad field change: ${field}`, 'dynamic search ad editor');
        }
      });

      this[field].subscribe(() => {
        logChange();
      });
    });
  }

  computeDisclaimerAsync(disclaimerCampaignId) {
    let params = {
      queryParameters: {
        entitySet: edmCampaign.currentAccount.Campaigns,
      },
      bypassCache: true,
    };

    jsDataCampaign.Campaign.find(disclaimerCampaignId, params)
      .then((data) => {
        const hasDisclaimer =  _.result(_.find(data.CampaignSettings, (setting) => {
          return setting['@odata.type'] === '#Model.DisclaimerSetting';
        }),
        'DisclaimerAdsEnabled');

        if (hasDisclaimer) {
          const scope = Object.create({
            campaignId: disclaimerCampaignId,
          });

          this.extensionsSharedRepos.association.findAll({
            where: scope,
          }).then((disclaimerdata) => {

            if (disclaimerdata && disclaimerdata.length > 0) {
              this.disclaimerInfo(disclaimerdata[0]);
            }
          });
        }
      });
    // TODO : catch and finally
  }
}
